import React from "react";

function Home() {
  return <div>Robins</div>;
}

export default Home;
